var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"hm-tab",class:{
    'hm-tab--active': _vm.active,
    'hm-tab--border-active': _vm.type === 'border-active',
    'hm-tab--text-active': _vm.type === 'text-active',
  },on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }